import { OptionsObject, useSnackbar } from 'notistack';
import { useFeedbackServiceSendFeedback, useFeedbackServiceUploadFeedbackAttachment } from '@/api/ui/queries';
import { UploadUrlResponse } from '@/api/ui/requests';
import useOrganisation from '@/hooks/useOrganisation';

const snackbarOptions: OptionsObject<'error'> = {
  preventDuplicate: true,
  anchorOrigin: { horizontal: 'left', vertical: 'bottom' },
  className: 'feedback-error',
  style: { backgroundColor: 'red' },
  autoHideDuration: 5000,
};

export function useFeedbackUpload() {
  const { enqueueSnackbar } = useSnackbar();
  const { mutateAsync: sendFeedbackAsync } = useFeedbackServiceSendFeedback();
  const { mutateAsync: uploadScreenShotAsync } = useFeedbackServiceUploadFeedbackAttachment();
  const { selectedOrganisationId, organisationName } = useOrganisation();

  const uploadAttachedImage = async (screenshot?: string): Promise<UploadUrlResponse> => {
    if (!screenshot) return { url: undefined };

    const imageBlob = await fetch(screenshot).then((r) => r.blob());
    return await uploadScreenShotAsync({
      xSelectedOrganisationId: selectedOrganisationId,
      formData: {
        file: imageBlob,
      },
    });
  };

  const onSubmit = async (data: { description: string; email: string; screenshot?: string }) => {
    try {
      let screenshotUrl = undefined;
      if (data.screenshot) {
        screenshotUrl = await uploadAttachedImage(data.screenshot).then((r) => r.url);
      }

      await sendFeedbackAsync({
        xSelectedOrganisationId: selectedOrganisationId,
        requestBody: {
          email: data.email,
          description: data.description,
          path: window.location.href,
          organisation: organisationName,
          screenshotUrl: screenshotUrl,
        },
      });
    } catch (err) {
      enqueueSnackbar(`Could not send feedback: ${err?.body?.message || err}`, snackbarOptions);
    }
  };

  return {
    onSubmit: onSubmit,
  };
}
